import { useState } from "react";
import { IconButton, TextField, Box, Modal, Typography, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";

const AddAnotherNameModal = (props) => {
  const [anotherName, setAnotherName] = useState("");
  const { multiLanguageData } = useSelector((state) => state?.main);
  const { TEXT_ADD_ANOTHER_NAME = English?.AddAnotherNameModal?.TEXT_ADD_ANOTHER_NAME } =
    multiLanguageData?.AddAnotherNameModal || {};

  const handleClose = () => {
    setAnotherName("");
    props.onClose();
  };

  const handleNameChange = async (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    setAnotherName(inputValue);
  };

  return (
    <Modal open={props?.open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography sx={{ pl: 1 }} variant="h6">
            {TEXT_ADD_ANOTHER_NAME}
          </Typography>

          <Stack direction={"row"}>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
            <IconButton
              color="primary"
              loading={props?.anotherFormLoader}
              variant="contained"
              onClick={() => {
                props.onAnotherNameSave(anotherName);
              }}
              disabled={!anotherName.trim()}>
              <SaveIcon />
            </IconButton>
          </Stack>
        </Box>
        <Stack sx={{ p: 1 }}>
          <TextField
            label={props?.label ?? ""}
            fullWidth
            variant="outlined"
            value={anotherName}
            onChange={(e) => handleNameChange(e)}
          />
        </Stack>
      </Box>
    </Modal>
  );
};

export default AddAnotherNameModal;
